import { Amplify } from "aws-amplify"; // keep root import for configure (modular submodules used elsewhere)
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { BrowserRouter as Router } from "react-router-dom";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import config from "./config.ts";
import App from "./App.tsx";
import "./main.css";

ModuleRegistry.registerModules([AllCommunityModule]);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
    },
  },
  Storage: {
    S3: {
      bucket: config.s3.BUCKET,
      region: config.s3.REGION,
    },
  },
  API: {
    REST: {
      // Root API (general routes: /notes, /portfolio, etc.)
      api: { endpoint: config.apiGateway.URL, region: config.apiGateway.REGION },
      // Backwards compatibility: legacy name used across existing notes code
      notes: { endpoint: config.apiGateway.URL, region: config.apiGateway.REGION },
      // Finance sub-service mounted at /finance
      finance: { endpoint: config.apiGateway.URL + "/finance", region: config.apiGateway.REGION },
    },
  },
});

// React 18 StrictMode intentionally double-invokes lifecycle/effects in development
// which causes our data fetching effects to run twice. This leads to a visible
// flicker (content -> cleared -> content) when navigating between pages that
// fetch immediately on mount. Removing StrictMode here avoids the double
// mount behavior during development. (StrictMode does not double-invoke in production build.)
ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <App />
    </Router>
  </QueryClientProvider>
);